var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6118 6.3709C42.8382 4.05808 39.6363 2.3142 36.1887 1.23884C32.7412 0.163484 29.1156 -0.222307 25.519 0.103502C21.9224 0.429306 18.4251 1.46033 15.227 3.13771C12.0288 4.81508 9.19233 7.10596 6.87952 9.87954C4.5667 12.6531 2.82283 15.8551 1.74747 19.3026C0.672104 22.7501 0.286314 26.3757 0.612122 29.9723C0.93793 33.569 1.96896 37.0662 3.64633 40.2644C5.32371 43.4625 7.61458 46.299 10.3882 48.6118L28 27.4914L45.6118 6.3709Z",
    fill: "#FE8331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount1);
export default __webpack_public_path__ + "static/media/count1.d1ade9cd05be25da7d4cb2af9914fcfc.svg";
export { ForwardRef as ReactComponent };